// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/Introduction.vue')
  },
  {
    path: '/history',
    name: 'AboutHistory',
    component: () => import('../views/AboutHistory.vue')
  },
  {
    path: '/leader',
    name: 'Leader',
    component: () => import('../views/Leader.vue')
  },
  {
    path: '/honors',
    name: 'Honors',
    component: () => import('../views/Honors.vue')
  },
  {
    path: '/project',
    name: 'Project',
    component: () => import('../views/Project.vue')
  },
  {
    path: '/chuxin-restaurant',
    name: 'ChuxinRestaurant',
    component: () => import('../views/projects/ChuxinRestaurant.vue')
  },
  {
    path: '/commercial-building',
    name: 'CommercialBuilding',
    component: () => import('../views/projects/CommercialBuilding.vue')
  },
  {
    path: '/ecological-park',
    name: 'EcologicalPark',
    component: () => import('../views/projects/EcologicalPark.vue')
  },
  {
    path: '/agriculture',
    name: 'Agriculture',
    component: () => import('../views/projects/Agriculture.vue')
  },
  {
    path: '/food-projects',
    name: 'FoodProjects',
    component: () => import('../views/projects/FoodProjects.vue')
  },
  {
    path: '/industrial-park',
    name: 'IndustrialPark',
    component: () => import('../views/projects/IndustrialPark.vue')
  },
  {
    path: '/comprehensive-building',
    name: 'ComprehensiveBuilding',
    component: () => import('../views/projects/ComprehensiveBuilding.vue')
  },
  {
    path: '/yuanlin',
    name: 'ProjectYuanlin',
    component: () => import('../views/projects/Yuanlin.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/charity',
    name: 'Charity',
    component: () => import('../views/Charity.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('../views/Message.vue')
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('../views/Jobs.vue')
  }
]

export default routes